import { makeStyles } from "tss-react/mui";

export default makeStyles()(() => ({
  container: {
    marginBottom: "20px",
  },
}));
